import { Button, ButtonProps, Popconfirm } from 'antd';
import { noop } from 'lodash-es';
import { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { DetectConflictBody, detectConflict, fetchMarketingTask } from 'services/api/oms';
import { detectConflict as detectPolicyConflict } from 'views/Aide/service';
import { isConfictScenarioType } from '../Scenario/config';

export function detectConflictCompatible(isPolicy: boolean) {
  return (body: DetectConflictBody) => {
    return isPolicy
      ? detectPolicyConflict(body).then(({ hasConflict, conflictPolicy }) => {
          return {
            hasConflict,
            conflictTasks: conflictPolicy.map(({ policyId, policyName }) => ({
              taskId: policyId,
              taskName: policyName,
            })),
          };
        })
      : detectConflict(body);
  };
}

export type ConflictSaveButtonProps = ButtonProps &
  Util.RequireAtLeastOne<{ taskId: number; stores: Marketing.TaskStore[] }> & {
    platform: General.PlatformUpperCase;
    region: General.UpperCaseRegion;
    scenarioType: Marketing.AllScenarioType;
    detect?: boolean;
    praiseTriggerPoint?: Marketing.PraiseTriggerPoint;
    isPolicy?: boolean;
  };

function ConflictSaveButton(props: ConflictSaveButtonProps) {
  const {
    platform,
    region,
    scenarioType,
    taskId,
    stores,
    detect = true,
    praiseTriggerPoint,
    isPolicy,
    onClick = noop,
    ...otherProps
  } = props;

  const { t } = useTranslate();

  const [visible, setVisible] = useState(false);

  return (
    <Popconfirm
      placement="topLeft"
      visible={visible}
      title={
        <div>
          {scenarioType === 'PRAISE_REMINDER'
            ? t('aide.检测到已配置买家签收后，发送已签收话术。')
            : t('aide.检测到已配置买家签收后，发送催好评话术。')}
          <br />
          {t('aide.买家签收后，系统会同时发送催好评、已签收话术。')}
        </div>
      }
      onCancel={() => setVisible(false)}
      onConfirm={(e) => {
        setVisible(false);
        onClick(e);
      }}
    >
      <Button
        {...otherProps}
        onClick={(e) => {
          if (
            !isConfictScenarioType(scenarioType) ||
            !detect ||
            (scenarioType === 'PRAISE_REMINDER' && praiseTriggerPoint === 'CONFIRMED')
          ) {
            return onClick(e);
          }

          return (
            stores
              ? Promise.resolve(stores)
              : fetchMarketingTask(taskId as number).then((task) => {
                  const { praiseTriggerPoint, stores } = task;

                  if (scenarioType === 'PRAISE_REMINDER' && praiseTriggerPoint !== 'SIGNED') {
                    return Promise.reject(new Error('Not need detect.'));
                  }

                  return stores;
                })
          )
            .then((stores) => {
              return detectConflictCompatible(isPolicy || false)({
                platform,
                region,
                scenarioType,
                stores,
              });
            })
            .then(({ hasConflict }) => {
              if (hasConflict) {
                setVisible(true);
              } else {
                onClick(e);
              }
            })
            .catch(() => {
              onClick(e);
            });
        }}
      />
    </Popconfirm>
  );
}

export default ConflictSaveButton;
